import { Accordion, AccordionDetails, AccordionSummary, Button, IconButton, styled, Theme } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

const $gutter = 30;

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const PastAuditionsContainer = styled(Button)(({ theme }) => ({
  background: '#242b35',
  height: 62,
  borderRadius: 8,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '10px 15px',
  gap: 15,
  // opacity: 0.5,
}));

export const PastAuditionsCount = styled('div')(({ theme }) => ({
  height: 31,
  width: 31,
  borderStyle: 'solid',
  borderWidth: '2px',
  borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
  borderImageSlice: '1',
  backgroundImage: 'linear-gradient(to bottom, #242b35, #242b35), linear-gradient(253deg, #d51bff, #00d4ff)',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '25px !important',
  WebkitBorderRadius: '25px !important',
  WebkitMaskImage: '-webkit-radial-gradient(circle, white 100%, black 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const PastAuditionsTextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginLeft: 10,

  '& > p': {
    lineHeight: 1.2,
  },
}));

export const CustomIconButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',
  pointerEvents: 'none',
  '& .MuiSvgIcon-root': {
    width: 11,
    height: 11,
  },
}));

export const Content = styled('div')(({ theme }) => ({
  marginTop: 10,
}));

export const ContentItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const AuditionItemsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 25%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter * 3}px)`,

  [theme.breakpoints.down(1850)]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${$gutter}px)`,
  },

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const Heading = styled(Typography)<Theme, { col?: string }>(({ col }) => ({
  position: 'relative',
  borderBottom: '1px solid #2d343e',
  alignItems: 'center',
  paddingBottom: 15,
  margin: '10px 0 20px',

  '&::before': {
    content: '""',
    background: `${col ? col : '#3e8bff'}`,
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const DetailsMainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '2em',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const LeftContainer = styled('div')(({ theme }) => ({
  height: 'fit-content',
  width: '35%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const RightContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
  width: '100%',
}));

export const MainCont = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const ProjectRoleCont = styled(Accordion)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#0b0f14' : COLORS.WHITE,
  border: theme.palette.type === 'dark' ? `1px solid ${COLORS.DARK_BORDER}` : `1px solid ${COLORS.LIGHT_BORDER}`,
  borderRadius: 8,
  padding: '20px 30px 25px 30px',
  width: '100%',
  position: 'relative',
  marginBottom: 20,
  transition: '300ms',
  [theme.breakpoints.down('xs')]: {
    padding: 15,
  },

  '& .Mui-expanded': {
    // paddingTop: 0,
  },

  '& .MuiAccordionSummary-content': {
    justifyContent: 'space-between',
  },
}));

export const HeaderCont = styled(AccordionSummary)(({ theme }) => ({
  padding: 0,
  display: 'flex',
}));

export const Body = styled(AccordionDetails)(({ theme }) => ({
  padding: 0,
}));
